import "src/pages/Reporting/Settings/components/DataStructure/DataPackageSlideout/styles_vanilla.css.ts.vanilla.css!=!../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/pages/Reporting/Settings/components/DataStructure/DataPackageSlideout/styles_vanilla.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA7VW0bKbIBB9v1_BzJ0-ekfUaEI-pkNkidwoWCSJaaf_3omYCjFqOrfxkT0sZ88eVj6-rzIowyJEv94QqiljQu4Do2qC4qhut87iThmjKoJwel3__fbRb8Xd1h3ND3utjpIFuSqVJuidZzzlKycFQaG7Meo2ngUzBUFZeDpfoQWIfWEIwmH4zQXHk6d0nwtN_oFQlPjFrJaOQWinNAMdaMrEsSFobVWyqwThukWNKgVD7zziGDxmqavy-PDMD4cdYIRav4DiDKnN2Bl3COr2EUdrP7q7K2q71JspB-RdIj86HHsHZi6nOOut_JRoff4nRBqzUSfQvFTn4EIQPRrlUoKOUkX1XsjJy8R9tWx4sqHL5UwUkh91c8XXSkgD2mNAimsVkyYbmXr_Rcq7FBJIF1gVj27OgpHmmiGeacbnS4fB4ZFuQ7icnxXVS7nJeW5qnlvdhbmSJuC0EuWFoEpJ1dQ0Bxf3wxsc_RWauv7WkbyEliC81N7GzbyyiZ_RqgT-H---s9YSVAjGQG77IoKm0EIe7n6JZjQsh9ixt2wb3H6ZcWiZWBsPzGgp9jJooOSkP8tQbdxcp7HyQ_BsreW7p099K2goZ9jXOvs8EXOIkzh1oRcPGg3QEGeb9caF_pzKCitIIHxg9MR7t4ztie1jh4mmLunFSjTIJgxUDUE52BGE0OexMYJfglxJA9L0koJkXk7sd-76475NwlJICP66ZYqwm2t-BAPlCU-eyBM9M-SwfVndklOgjOYeIPlqaeg20QM4gTQNQVJJ8M-YLdloKpuaapCei_HKo55FGU79tOkSwHty9dc_dF-9_XPASvsHt__ujC4LAAA\"}!../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var ancestorOnlyText = '_57el0h13';
export var container = '_57el0h2';
export var drawerBody = '_57el0h1';
export var editorWrapper = '_57el0hw';
export var editorWrapperError = '_57el0hx';
export var editorWrapperSuccess = '_57el0hy';
export var fieldSelectorPanel = '_57el0hs';
export var formulaCard = '_57el0hu';
export var formulaTakeoverBody = '_57el0ht';
export var formulaTakeoverBodyWrapper = '_57el0hq';
export var formulaTakeoverFormArea = '_57el0hr';
export var formulaTakeoverLoading = '_57el0hv';
export var formulasPanel = '_57el0hj';
export var formulasPanelHeader = '_57el0hk';
export var formulasTableContainer = '_57el0hl';
export var hierarchyDetailsContent = '_57el0h9';
export var hierarchyDetailsLabel = '_57el0ha';
export var hierarchyDetailsPanel = '_57el0h8';
export var hierarchyDetailsTitle = '_57el0h15';
export var hierarchyPanel = '_57el0h5';
export var hierarchyPanelHeader = '_57el0h6';
export var hierarchyTableContainer = '_57el0h7';
export var insertButton = '_57el0h11';
export var insertColumnCell = '_57el0h10';
export var insertFieldsButton = '_57el0h17';
export var insertedButton = '_57el0h14';
export var monospaceText = '_57el0hp';
export var noResultsContainer = '_57el0hz';
export var noRowsOverlayIcon = '_57el0h12';
export var queriesPanel = '_57el0hm';
export var queriesPanelHeader = '_57el0hn';
export var queriesTableContainer = '_57el0ho';
export var queryPanelTitle = '_57el0h16';
export var slideoutHeader = '_57el0h0';
export var tabContent = '_57el0h4';
export var tabs = '_57el0h3';
export var versionHistoryBody = '_57el0hb';
export var versionHistoryContainer = '_57el0hc';
export var versionHistoryItem = '_57el0hf';
export var versionHistoryItemSelected = '_57el0hg';
export var versionHistoryLeftPanel = '_57el0hd';
export var versionHistoryLeftPanelTitle = '_57el0he';
export var versionHistoryPreviewHeader = '_57el0hi';
export var versionHistoryRightPanel = '_57el0hh';